"use client"

import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastTitle,
  ToastViewport,
  ToastAction,
  getDefaultIcon,
} from "@/components/ui/toast"
import { Icon } from "@/components/ui/Icon"

export function Toaster({ position }: { position?: 'left' | 'right' }) {
  const { toasts } = useToast()

  return (
    <>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        const iconName = getDefaultIcon(variant || 'default')
        
        return (
          <Toast key={id} variant={variant} {...props}>
            {iconName && (
              <Icon name={iconName} size="md" />
            )}
            <div className="flex-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport position={position} />
    </>
  )
}
